var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoValueIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 26,
    viewBox: "0 0 142 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8386_131664)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.9432,
    y1: -0.797704,
    x2: -3.92627,
    y2: 11.0718,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.92129,
    y1: 1.18081,
    x2: -1.94818,
    y2: 13.0503,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3832,
    y1: 1.67495,
    x2: -0.46451,
    y2: 15.5227,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3509,
    y1: 2.66421,
    x2: -1.45329,
    y2: 20.4684,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3509,
    y1: 6.62124,
    x2: -1.45329,
    y2: 24.4254,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3509,
    y1: 10.5773,
    x2: -1.45329,
    y2: 28.3815,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3509,
    y1: 14.5343,
    x2: -1.45329,
    y2: 32.3385,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3509,
    y1: 18.4904,
    x2: -1.45329,
    y2: 36.2946,
    stroke: "black",
    strokeWidth: 1.48368
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8386_131664)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 26.1095,
    y1: -0.797704,
    x2: 14.2401,
    y2: 11.0718,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.0875,
    y1: 1.18081,
    x2: 16.2181,
    y2: 13.0503,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.5495,
    y1: 1.67495,
    x2: 17.7017,
    y2: 15.5227,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.5172,
    y1: 2.66421,
    x2: 16.713,
    y2: 20.4684,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.5172,
    y1: 6.62124,
    x2: 16.713,
    y2: 24.4254,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.5172,
    y1: 10.5773,
    x2: 16.713,
    y2: 28.3815,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.5172,
    y1: 14.5343,
    x2: 16.713,
    y2: 32.3385,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.5172,
    y1: 18.4904,
    x2: 16.713,
    y2: 36.2946,
    stroke: "black",
    strokeWidth: 1.48368
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8386_131664)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 44.2754,
    y1: -0.797704,
    x2: 32.4059,
    y2: 11.0718,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2541,
    y1: 1.18081,
    x2: 34.3846,
    y2: 13.0503,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.7154,
    y1: 1.67495,
    x2: 35.8676,
    y2: 15.5227,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.6831,
    y1: 2.66421,
    x2: 34.8789,
    y2: 20.4684,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.6831,
    y1: 6.62124,
    x2: 34.8789,
    y2: 24.4254,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.6831,
    y1: 10.5773,
    x2: 34.8789,
    y2: 28.3815,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.6831,
    y1: 14.5343,
    x2: 34.8789,
    y2: 32.3385,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.6831,
    y1: 18.4904,
    x2: 34.8789,
    y2: 36.2946,
    stroke: "black",
    strokeWidth: 1.48368
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_8386_131664)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 62.4417,
    y1: -0.797704,
    x2: 50.5722,
    y2: 11.0718,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.4197,
    y1: 1.18081,
    x2: 52.5502,
    y2: 13.0503,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.8816,
    y1: 1.67495,
    x2: 54.0339,
    y2: 15.5227,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.8493,
    y1: 2.66421,
    x2: 53.0451,
    y2: 20.4684,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.8493,
    y1: 6.62124,
    x2: 53.0451,
    y2: 24.4254,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.8493,
    y1: 10.5773,
    x2: 53.0451,
    y2: 28.3815,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.8493,
    y1: 14.5343,
    x2: 53.0451,
    y2: 32.3385,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.8493,
    y1: 18.4904,
    x2: 53.0451,
    y2: 36.2946,
    stroke: "black",
    strokeWidth: 1.48368
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_8386_131664)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 80.6074,
    y1: -0.797704,
    x2: 68.7379,
    y2: 11.0718,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.5861,
    y1: 1.18081,
    x2: 70.7166,
    y2: 13.0503,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.0473,
    y1: 1.67495,
    x2: 72.1996,
    y2: 15.5227,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.0157,
    y1: 2.66421,
    x2: 71.2115,
    y2: 20.4684,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.0157,
    y1: 6.62124,
    x2: 71.2115,
    y2: 24.4254,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.0157,
    y1: 10.5773,
    x2: 71.2115,
    y2: 28.3815,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.0157,
    y1: 14.5343,
    x2: 71.2115,
    y2: 32.3385,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.0157,
    y1: 18.4904,
    x2: 71.2115,
    y2: 36.2946,
    stroke: "black",
    strokeWidth: 1.48368
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_8386_131664)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 98.7738,
    y1: -0.797704,
    x2: 86.9044,
    y2: 11.0718,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.752,
    y1: 1.18081,
    x2: 88.8824,
    y2: 13.0503,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.214,
    y1: 1.67495,
    x2: 90.3661,
    y2: 15.5227,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.181,
    y1: 2.66421,
    x2: 89.3773,
    y2: 20.4684,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.181,
    y1: 6.62124,
    x2: 89.3773,
    y2: 24.4254,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.181,
    y1: 10.5773,
    x2: 89.3773,
    y2: 28.3815,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.181,
    y1: 14.5343,
    x2: 89.3773,
    y2: 32.3385,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.181,
    y1: 18.4904,
    x2: 89.3773,
    y2: 36.2946,
    stroke: "black",
    strokeWidth: 1.48368
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_8386_131664)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 116.94,
    y1: -0.797704,
    x2: 105.07,
    y2: 11.0718,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.918,
    y1: 1.18081,
    x2: 107.049,
    y2: 13.0503,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.38,
    y1: 1.67495,
    x2: 108.532,
    y2: 15.5227,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.348,
    y1: 2.66421,
    x2: 107.544,
    y2: 20.4684,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.348,
    y1: 6.62124,
    x2: 107.544,
    y2: 24.4254,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.348,
    y1: 10.5773,
    x2: 107.544,
    y2: 28.3815,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.348,
    y1: 14.5343,
    x2: 107.544,
    y2: 32.3385,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.348,
    y1: 18.4904,
    x2: 107.544,
    y2: 36.2946,
    stroke: "black",
    strokeWidth: 1.48368
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_8386_131664)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 135.106,
    y1: -0.797704,
    x2: 123.236,
    y2: 11.0718,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.084,
    y1: 1.18081,
    x2: 125.215,
    y2: 13.0503,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.546,
    y1: 1.67495,
    x2: 126.699,
    y2: 15.5227,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.514,
    y1: 2.66421,
    x2: 125.71,
    y2: 20.4684,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.514,
    y1: 6.62124,
    x2: 125.71,
    y2: 24.4254,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.514,
    y1: 10.5773,
    x2: 125.71,
    y2: 28.3815,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.514,
    y1: 14.5343,
    x2: 125.71,
    y2: 32.3385,
    stroke: "black",
    strokeWidth: 1.48368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.514,
    y1: 18.4904,
    x2: 125.71,
    y2: 36.2946,
    stroke: "black",
    strokeWidth: 1.48368
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8386_131664"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.65625,
    width: 14.8368,
    height: 24.7281,
    rx: 7.41842,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8386_131664"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.1661,
    y: 0.65625,
    width: 14.8368,
    height: 24.7281,
    rx: 7.41842,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8386_131664"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.3323,
    y: 0.65625,
    width: 14.8368,
    height: 24.7281,
    rx: 7.41842,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_8386_131664"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.4985,
    y: 0.65625,
    width: 14.8368,
    height: 24.7281,
    rx: 7.41842,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_8386_131664"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.6647,
    y: 0.65625,
    width: 14.8368,
    height: 24.7281,
    rx: 7.41842,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_8386_131664"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.8308,
    y: 0.65625,
    width: 14.8368,
    height: 24.7281,
    rx: 7.41842,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_8386_131664"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.997,
    y: 0.65625,
    width: 14.8368,
    height: 24.7281,
    rx: 7.41842,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_8386_131664"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.163,
    y: 0.65625,
    width: 14.8368,
    height: 24.7281,
    rx: 7.41842,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoValueIcon);
export default __webpack_public_path__ + "static/media/no-value-icon.2a4c25e8531cbf352ff44913525bd29e.svg";
export { ForwardRef as ReactComponent };